import { Component } from '@angular/core';

@Component({
  selector: 'app-plans.component',
  imports: [],
  templateUrl: './plans.component.html',
  styleUrl: './plans.component.scss',
})
export class PlansComponent {

}
